export default __webpack_public_path__ + "static/media/carolina_llerena.21b51469.jpg";